// extracted by mini-css-extract-plugin
module.exports = {"container":"_3_rni_","column":"tMEr2M","ads":"_3-K6bx","wideMain":"_1fvz2w","main":"_2PDlFG","oneCol":"_1xOvx2","aside":"_3TzC5r","grid":"uU5blD"};